import type { Agent } from "@/types/api"

import { cn } from "@/lib/utils"

export interface SlashCommand {
  cmd: string
  description: string
  agent: Agent
}

export function buildSlashCommands(agents: Agent[]): SlashCommand[] {
  return agents.map((agent) => ({
    cmd: `/${agent.id}`,
    description: agent.description || agent.label,
    agent,
  }))
}

export function SlashMenu({
  commands,
  activeIndex,
  onSelect,
}: {
  commands: SlashCommand[]
  activeIndex: number
  onSelect: (command: SlashCommand) => void
}) {
  if (!commands.length) return null

  return (
    <div className="absolute right-0 bottom-full left-0 z-20 mb-2 overflow-hidden rounded-xl border bg-popover shadow-lg animate-in fade-in slide-in-from-bottom-1 duration-150">
      {commands.map((command, i) => (
        <button
          key={command.cmd}
          type="button"
          // mousedown so selection wins over the textarea blur
          onMouseDown={(e) => {
            e.preventDefault()
            onSelect(command)
          }}
          className={cn(
            "flex w-full items-center gap-2.5 px-3.5 py-2.5 text-left transition-colors",
            i === activeIndex ? "bg-accent" : "hover:bg-accent/60",
          )}
        >
          <span className="font-mono text-[13px] font-semibold text-primary">{command.cmd}</span>
          <span className="truncate text-[13px] text-muted-foreground">{command.description}</span>
        </button>
      ))}
    </div>
  )
}
